import React, { Component } from 'react'
import Grid from "../../components/grid";
import { connect } from "react-redux";
import './style.scss';
import { GetEins, getPPDBudget, addUpdateBudget, getChildCCByTreeIndex, getAdminSettings } from '../../store/actions';
import { has, } from 'lodash';
class PPDBudgetView extends Component {

    state = {
        einList: [],
        rowData: [],
        columnDefs: [],
        jobList: [],
        departmentList: [],
    };

    getAllData = async () => {
        await this.props.getAdminSettings(this.props.UserReducer.company.toUpperCase());
        if (this.props.PPD_ADMIN_SETTINGS_GET.hasOwnProperty("departmentCCIndex")) {
            let treeIndex = this.props.PPD_ADMIN_SETTINGS_GET.departmentCCIndex;
            let level = this.props.PPD_ADMIN_SETTINGS_GET.departmentCCLevel;
            await this.props.getChildCCByTreeIndex({ companyShortName: this.props.UserReducer.company.toUpperCase(), treeIndex, levelQuery: (level || 1) });
        };
        await this.props.getPPDBudget(this.props.UserReducer.company.toUpperCase());
    }

    onGridReady = async (params) => {
        this.gridApi = params.api;
    };

    onCellValueChange = async props => {
        let { data, value, colDef } = props;
        let companyShortName = this.props.UserReducer.company;
        let budgetRecord = { companyShortName };
        let { field, headerName } = colDef;
        if (this.state.isMultiEIN && field.includes("PPDBudget")) {
            let colData = (data[headerName] || {});
            budgetRecord.EINName = colData.EINName || headerName;
        }
        budgetRecord.jobName = data.jobName;
        budgetRecord.isClinical = data.isClinical;
        budgetRecord.isMultiEIN = this.state.isMultiEIN;
        budgetRecord.PPDBudget = this.state.isMultiEIN ? data[headerName]?.PPDBudget : data.PPDBudget;
        if (data.department) budgetRecord.department = data.department;
        if (budgetRecord.PPDBudget) this.props.addUpdateBudget({ ...budgetRecord });
        return;
    };

    async componentDidMount() {
        let isMultiEIN = has(this.props.ClientDataReducer, "isMultiEIN") ? this.props.ClientDataReducer.isMultiEIN : this.props.UserReducer.companyDetails.isMultiEIN;
        await this.getAllData();
        let ppdBudget = this.props.PPD_BUDGET.map(el => {
            let copy = {};
            for (let p in el) {
                if (typeof el[p] === 'object') {
                    copy = { ...copy, [p]: { ...el[p] } };
                } else copy = { ...copy, [p]: el[p] }
            };
            return copy;
        }) || [];
        let departmentList = [...(this.props.CHILD_COST_CENTERS || [])];
        let columnDefs = [{
            headerName: "Job",
            field: "jobName",
            pinned: 'left',
        }, {
            headerName: "Department",
            field: "department",
            editable: true,
            pinned: 'left',
            singleClickEdit: props => !props.value,
            cellEditor: 'agRichSelectCellEditor',
            cellEditorPopup: false,
            cellEditorParams: {
                values: departmentList.map(dept => dept.name),
                searchType: "matchAny",
                allowTyping: true,
                filterList: true,
                highlightMatch: true,
                valueListMaxHeight: 200,
            }
        }, {
            headerName: "Is Clinical",
            field: "isClinical",
            editable: true,
            pinned: "left",
            cellEditor: "agCheckboxCellRenderer",
            cellDataType: 'boolean'
        }];
        let einList = [];
        if (isMultiEIN) {
            await this.props.GetEins(this.props.UserReducer.companyId);
            einList = this.props.EINS.records;
            einList.forEach(ein => {
                let { companyEIN } = ein;
                columnDefs.push({
                    headerName: companyEIN,
                    field: `${companyEIN}.PPDBudget`,
                    editable: true,
                    singleClickEdit: props => !props.value,
                    cellEditor: "agNumberCellEditor",
                    cellEditorParams: {
                        precision: 2,
                        step: 0.01,
                        showStepperButtons: true,
                        min: 0
                    },
                });
            });
        } else {
            columnDefs.push({
                headerName: "Budget",
                field: "PPDBudget",
                editable: true,
                singleClickEdit: props => !props.value,
                cellEditor: "agNumberCellEditor",
                cellEditorParams: {
                    precision: 2,
                    step: 0.01,
                    showStepperButtons: true,
                    min: 0,
                },
            });
        };
        this.setState({ isMultiEIN, einList, columnDefs, rowData: [...ppdBudget], departmentList });
    };

    render() {
        const { rowData, columnDefs, } = this.state;
        return (
            <div>
                <div className="route_page rate_setup_page location-wage">
                    <div className="rates_list">
                        <h4 className="heading_h4">Budget</h4>
                        <div className="list">
                            <Grid
                                rowData={rowData}
                                columnDefs={columnDefs}
                                height="650px"
                                onGridReady={this.onGridReady}
                                onCellValueChanged={this.onCellValueChange}
                                showStatusBar={true}
                            >
                            </Grid>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
};

const mapStateToProps = ({ UserReducer,
    PPDReducer,
    EINReducer,
    ClientDataReducer,
    CostCenterReducer,
}) => {
    let { PPD_CENSUS_DATA, PPD_BUDGET, PPD_BUDGET_SAVE, PPD_ADMIN_SETTINGS_GET } = PPDReducer;
    let { EINS } = EINReducer;
    let { CHILD_COST_CENTERS } = CostCenterReducer;
    return {
        UserReducer,
        PPD_CENSUS_DATA,
        EINS,
        ClientDataReducer,
        PPD_BUDGET,
        PPD_BUDGET_SAVE,
        PPD_ADMIN_SETTINGS_GET,
        CHILD_COST_CENTERS,
    };
};
export default connect(mapStateToProps, {
    GetEins,
    getPPDBudget,
    addUpdateBudget,
    getChildCCByTreeIndex,
    getAdminSettings
})(PPDBudgetView);
